


import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAAlufXQTTk3HZm_lypcypp5CVNj1Mp2J0",
  authDomain: "ayuja-d237b.firebaseapp.com",
  projectId: "ayuja-d237b",
  storageBucket: "ayuja-d237b.firebasestorage.app",
  messagingSenderId: "531525746381",
  appId: "1:531525746381:web:91bf4435053e08fd2ab384",
};

const app = initializeApp(firebaseConfig);

export const registerWebToken = async () => {
  try {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return console.log('Notifications not allowed');
    }

    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      console.log('Service Worker registered:', registration);

      const messaging = getMessaging(app);
      // const token = await getToken(messaging, {
      //   vapidKey: "BNlfYcfAAnPuHFcsYdHaDlRWBj0neFmI_Mg4kWY3ZVZVi2HsFc0TV2GMZctnp3EypKao3NHTysCcJoPS0H4aY-w",
      //   serviceWorkerRegistration: registration,
      // });
      const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
      const token = await getToken(messaging, { vapidKey,serviceWorkerRegistration: registration, });
      if (token) {
        console.log('Web FCM Token:', token);

        // Send token to backend
        // await fetch('https://ec5d2cf25396.ngrok-free.app/api/flask/notify/register_token', {
          await fetch(`${process.env.REACT_APP_FCM_REGISTER_TOKEN}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        console.log('Token stored in backend');
      } else {
        console.log('No token available');
      }
    } else {
      console.error('Service Workers not supported');
    }
  } catch (err) {
    console.error('Web FCM error:', err);
  }
};
